"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.logOut = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var Sentry = _interopRequireWildcard(require("@sentry/browser"));

var actions = _interopRequireWildcard(require("../../constants"));

var _helpers = require("../../helpers");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

var logOutRequest = function logOutRequest() {
  return {
    type: actions.LOG_OUT_REQUEST
  };
};

var logOutSuccess = function logOutSuccess() {
  return {
    type: actions.LOG_OUT_SUCCESS
  };
};

var logOutFailure = function logOutFailure(error) {
  return {
    type: actions.LOG_OUT_FAILURE,
    error: error
  };
};

var logOut = function logOut(callback) {
  return /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regenerator["default"].mark(function _callee(dispatch, getState) {
      return _regenerator["default"].wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              // TODO: Call logout API once it has been created. For now, just clearing state.
              dispatch(logOutRequest());
              (0, _helpers.removeCookie)();
              _context.prev = 2;
              _context.next = 5;
              return dispatch(logOutSuccess());

            case 5:
              if (!callback) {
                _context.next = 8;
                break;
              }

              _context.next = 8;
              return dispatch(callback());

            case 8:
              return _context.abrupt("return", true);

            case 11:
              _context.prev = 11;
              _context.t0 = _context["catch"](2);
              dispatch(logOutFailure(_context.t0));
              Sentry.captureException(_context.t0);
              console.error(_context.t0);

            case 16:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[2, 11]]);
    }));

    return function (_x, _x2) {
      return _ref.apply(this, arguments);
    };
  }();
};

exports.logOut = logOut;